import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { IconButton, InputAdornment, Paper, ThemeProvider } from '@mui/material';
import { FormApi } from 'final-form';
import { useField } from 'react-final-form';
import { lighten, styled } from '@mui/system';
import { theme } from 'components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper';
import { Add } from '@mui/icons-material';

interface value {
    id: number
    id_group: null
    is_meeting: "Y" | "N"
    is_meeting_pack: "Y" | "N"
    name: string
    parent_id: null
}
function CustomPaper({ children }: { children: Element }) {
    return (
        <Paper
            sx={{
                bgcolor: "rgb(96, 96, 96)",
                color: '#fff',
                fontWeight: 700,
                "& .MuiAutocomplete-listbox": {
                    "& .MuiAutocomplete-option[aria-selected='true']": {
                        bgcolor: theme => theme.palette.primary.light,
                        color: '#fff',
                        "&.Mui-focused": {
                            bgcolor: theme => theme.palette.primary.light,
                            color: '#fff',
                        }
                    }
                },

            }}
        >
            {children}
        </Paper>
    );
}

export default function MeetingPackAutocomplete({ options, form, canCreateFolder, meetingPackContainerRef, label, name, disabled, group }: { options: Array<any>, form: FormApi, canCreateFolder?: boolean, meetingPackContainerRef?: React.MutableRefObject<HTMLInputElement>, label?: string, disabled: boolean, name: string, group: number | string | null }) {
    const [value, setValue] = React.useState<value | null>(null);
    // const [inputValue, setInputValue] = React.useState('');
    const [fieldWidth, setFieldWidth] = React.useState<number>(meetingPackContainerRef?.current !== undefined && meetingPackContainerRef.current !== null ? meetingPackContainerRef.current.clientWidth : 100);
    const validateName = (value: number | string | null) => {
        if (!value) {
            return 'Required';
        }
    };
    const optionsWithGroup = options.map((option) => {
        const firstLetter = option && typeof option.name === 'string' ? option.name[0].toUpperCase() : 0;
        return {
            firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
            ...option,
        };
    });
    const { meta, input } = useField(name, { validate: validateName })

    const GroupHeader = styled('div')(({ theme }) => ({
        position: 'sticky',
        top: '-8px',
        padding: '4px 10px',
        color: '#000',
        backgroundColor: lighten('rgb(117,117,117)', 0.1)
    }));

    const GroupItems = styled('ul')({
        padding: 0,
    });

    React.useEffect(() => {
        const handleWindowResize = () => {
            meetingPackContainerRef?.current !== undefined && meetingPackContainerRef.current !== null && setFieldWidth(meetingPackContainerRef.current.clientWidth * .8)

        }
        window.addEventListener('resize', handleWindowResize)
        return () => {
            window.removeEventListener('resize', handleWindowResize)
        }
    })
    // const childTheme = createTheme({
    //     components: {
    //         MuiTextField: {
    //             defaultProps: {
    //                 color: 'success',
    //             },
    //             styleOverrides: {
    //                 root: {
    //                     '& 	.MuiInput-formControl': {
    //                         color: lighten(theme.palette.success.main, .7),
    //                     },


    //                 },
    //             },
    //         },
    //     },
    // }, theme);
    React.useEffect(() => {
        setValue(null)
        form.change(input.name, null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [group])

    return (
        <ThemeProvider theme={theme}>

            <Autocomplete
                value={value}
                size='small'
                onChange={(_: any, newValue: value | null) => {
                    if (newValue !== null && newValue !== undefined && 'id' in newValue) {
                        setValue(newValue);
                        form.change(input.name, newValue.id)
                    } else {
                        setValue(null)
                        form.change(input.name, null)
                    }
                }}
                disabled={disabled}
                groupBy={(option) => option.firstLetter}
                disablePortal
                forcePopupIcon={false}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => {
                    return option?.id === value.id
                }}
                renderOption={(props, option, { inputValue }) => {
                    const matches = match(option.name, inputValue, { insideWords: true });
                    const parts = parse(option.name, matches);

                    return (
                        <li {...props}>
                            <div>
                                {parts.map((part: { text: string, highlight: boolean }, index: number) => (
                                    <span
                                        key={index}
                                        style={{
                                            fontWeight: part.highlight ? 700 : 400,
                                            color: part.highlight ? '#E1C699' : 'inherit'
                                        }}
                                    >
                                        {part.text}
                                    </span>
                                ))}
                            </div>
                        </li>
                    );
                }}
                id="meeting_packs"
                options={Array.isArray(optionsWithGroup) ? optionsWithGroup.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter)) : []}
                renderGroup={(params) => (
                    <li key={params.key}>
                        <GroupHeader>{params.group}</GroupHeader>
                        <GroupItems>{params.children}</GroupItems>
                    </li>
                )}
                // @ts-expect-error
                PaperComponent={CustomPaper}
                renderInput={(params) => {
                    return (
                        <TextField
                            {...params}
                            fullWidth
                            error={(meta.error && meta.touched) || (canCreateFolder !== undefined && canCreateFolder === false)}
                            {...((meta.error && meta.touched) ? { helperText: meta.error } : (canCreateFolder !== undefined && canCreateFolder === false) ? { helperText: 'Permission Denied' } : {})}
                            label={label ?? "Meeting Pack"}

                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end" sx={{ display: 'flex', flexDirection: 'row' }}>
                                        {params.InputProps.endAdornment}
                                        <IconButton
                                            size='small'
                                            color='success'
                                            // @ts-expect-error
                                            onClick={() => window.$("#meetingPacksModal").modal("show")}
                                            disabled={disabled}
                                            edge="end"
                                        >
                                            <Add />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            color='success'
                            sx={{
                                '& .MuiAutocomplete-clearIndicator': {
                                    color: theme => theme.palette.error.main,
                                },
                                '& .MuiAutocomplete-endAdornment': {
                                    position: 'relative',
                                    right: 0,
                                    top: 0
                                },
                                '& .MuiAutocomplete-inputRoot': {
                                    pr: '0 !important',
                                },

                                mt: (meta.error && meta.touched) || (canCreateFolder !== undefined && canCreateFolder === false) ? 2 : .5
                            }}
                            onFocus={() => {
                                form.focus(input.name)
                            }}
                            onBlur={() => {
                                if (value === null || value === undefined) {
                                    form.blur(input.name);
                                }
                            }}
                            variant='standard'
                        />
                    )
                }}
                sx={{
                    minWidth: fieldWidth,

                }}
            />
        </ThemeProvider>
    );
}
